module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-Light-f6d64b900ba7de4a96c7fe7345bef28f.ttf";